import { addAppFlagToLinks } from './app';

export function faqs() {
    const input = document.getElementById('faqs-search-input');
    const results = document.getElementById('faqs-search-results');

    if(!input || !results) return;

    const params = new URLSearchParams(window.location.search);
    const initialTerm = params.get('s') ?? '';

    if(initialTerm){
        input.value = initialTerm;
        search(initialTerm);
    }

    input.addEventListener('input', function (){ 
        const term = this.value.trim();

        if (term.length < 2) {
            results.style.display = 'none';
            results.innerHTML     = '';
            return;
        }

        search(term);
    });

    input.addEventListener('keydown', function(e){
        if(e.key !== 'Enter') return;

        const term = this.value.trim();
        if (!term) return;

        const url = new URL(window.location.origin + '/faqs/');
        url.searchParams.set('s', term);
        window.history.pushState({}, '', url);
    });

    function normalize(text) {
        if (!text) return '';
        return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    function search(term){
        const faqs = window.GBM_FAQS ?? [];
        const normTerm = normalize(term); 
        let matches = faqs.map(faq => {
            const normTitle = normalize(faq.title);
            const normContent = normalize(faq.content);
            let score = 0;
            if (normTitle.includes(normTerm)) {
                score += 10;
            }
            if (normContent.includes(normTerm)) {
                score += 1;
            }

            return { ...faq, score };
        });

        matches = matches.filter(faq => faq.score > 0);
        matches.sort((a, b) => b.score - a.score);

        render(matches, term);
    }

    function highlight(text, term) {
        const normTerm = normalize(term);
        if (!normTerm) return text;

        const normText = normalize(text);
        const startIndex = normText.indexOf(normTerm);

        if (startIndex !== -1) {
            const originalMatch = text.substring(startIndex, startIndex + term.length);
            const regex = new RegExp(`(${escapeRegex(originalMatch)})`, 'gi');
            return text.replace(regex, '<mark>$1</mark>');
        }

        return text;
    }

    function escapeRegex(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function render(matches, term) {
        if (!matches.length) {
            results.innerHTML     = '<p class="faqs-no-results">No se encontraron resultados.</p>';
            results.style.display = 'block';
            return;
        }

        const html = matches.map(faq => `
            <a href="/faqs/${faq.slug}" class="faqs-search-result-item">
                <span class="faqs-result-category">${faq.category.title}</span>
                <span class="faqs-result-title">${highlight(faq.title, term)}</span>
            </a>
        `).join('');

        results.innerHTML     = html;
        results.style.display = 'block';
        addAppFlagToLinks(results);
    }
}